var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.336,
    height: 9.615,
    viewBox: "0 0 12.336 9.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2268",
    "data-name": "Group 2268",
    transform: "translate(-126.504 -489.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3505",
    "data-name": "Path 3505",
    d: "M18018.818-4981.075a9.643,9.643,0,0,1,11.721,0",
    transform: "translate(-17892 5473)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3506",
    "data-name": "Path 3506",
    d: "M18018.818-4981.826a6.074,6.074,0,0,1,7.383,0",
    transform: "translate(-17889.832 5476.375)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    transform: "translate(18023 -4977.27)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17890.501953125 5475.3642578125 L -17891.072265625 5474.49951171875 L -17889.9296875 5474.49951171875 L -17890.501953125 5475.3642578125 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -17890.501953125 5476.271484375 L -17891.94140625 5474.09033203125 C -17891.93359375 5474.0595703125 -17891.923828125 5474.02978515625 -17891.916015625 5473.99951171875 L -17889.0859375 5473.99951171875 C -17889.078125 5474.02880859375 -17889.068359375 5474.0595703125 -17889.060546875 5474.08984375 L -17890.501953125 5476.271484375 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3507",
    "data-name": "Path 3507",
    d: "M18023.057-4976.516a2.009,2.009,0,0,1,2.684,0",
    transform: "translate(-17891.877 5473.515)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.4759f3434e4644de4bab16120ed086a2.svg";
export { ForwardRef as ReactComponent };